import { TLCEvents } from "../../../../js/lib/events/events";
import { TLCLogger } from "../../../../js/lib/logger";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { LS2KIDS_CONSTANTS } from "../constants";
import { KidsMessaging } from "../messaging";

export class KidsHistoryManager {
	constructor() { }
	/**
	 * Main init method will add any listeners and sets a routes table. It also will fire hashChange
	 * so the application can resume or start.
	 *
	 * @param {tlc.ls2kids.RoutesTable} routes the routes table
	 */
	static init(routes) {
		KidsHistoryManager._routesTable = routes;
		KidsHistoryManager.addListeners();


		if (window.navigator.standalone) {
			KidsHistoryManager.navigate(LS2KIDS_CONSTANTS.Urls.home);
		} else {
			KidsHistoryManager._onHashChange();
		}
	}
	/**
	 * Any listeners for the history manager.
	 */
	static addListeners() {
		$(window).on('hashchange', KidsHistoryManager._onHashChange);

		TLCEvents.on(LS2PAC_CONSTANTS.Events.onLogoutResponse, KidsHistoryManager.onLogoutResponse);
	}
	static onLogoutResponse() {
		KidsHistoryManager.navigate(LS2KIDS_CONSTANTS.Urls.__start);
	}
	/**
	 * Hash change handler. Fires from jQuery.
	 *
	 * @param {jQuery.event} e
	 * @private
	 */
	static _onHashChange(e) {
		var url = KidsHistoryManager._getHash(), query = KidsHistoryManager._getQueryStringObjectFromHash();

		KidsHistoryManager._query = query;

		KidsHistoryManager._previousPage = KidsHistoryManager._currentPage;
		KidsHistoryManager._currentPage = {
			url: url,
			query: query
		};

		var eventData = $.extend(
			{
				history: {
					previous: KidsHistoryManager._previousPage,
					current: KidsHistoryManager._currentPage
				}
			},
			query
		);

		TLCLogger.log('the url hash has changed to "' + url + '"', e, eventData);

		// a new session has started, navigating will cause this to fire again.
		if (url.length == 0) {
			TLCLogger.log('setting the hash to default start', e, url, eventData);

			KidsHistoryManager.navigate(LS2KIDS_CONSTANTS.Urls.home, query);
		} else {

			KidsMessaging.hide(false);

			KidsHistoryManager._routesTable.route(url, eventData);
		}
	}
	/**
	 * Provide the ability to change what the previous page the user visited.
	 * @param obj
	 */
	static setCurrentPage(obj) {
		KidsHistoryManager._currentPage = obj;
	}
	/**
	 * Provide the ability to change what the previous page the user visited.
	 * @param obj
	 */
	static getPreviousPage(obj) {
		return KidsHistoryManager._previousPage;
	}
	/**
	 * Get a value from the querystring from its key.
	 *
	 * @param {string} key the querystring's key to retrieve
	 * @return {string}
	 */
	static getQueryByKey(key) {
		return KidsHistoryManager._query[key];
	}
	/**
	 *
	 * @param {string} url
	 * @param {object=} query
	 * @returns {string}
	 */
	static createUrl(url, query) {
		var newHash = url;

		if (query != null) {
			var str = KidsHistoryManager._convertObjectToQueryString(query);

			if (str.length > 0) {
				newHash += '?' + str;
			}
		}

		return newHash;
	}
	/**
	 * Navigate to a new URL. You can pass an object which resembles its query.
	 * @param {string} url
	 * @param {object=} query
	 */
	static navigate(url, query) {
		location.hash = KidsHistoryManager.createUrl(url, query);
	}
	/**
	 * Get the query string of the hash.
	 * @return {object|null}
	 * @private
	 */
	static _getQueryStringObjectFromHash() {
		var hash = location.href.substr(location.href.indexOf("#") + 1);
		var queryIndex = hash.indexOf('?');

		if (queryIndex == -1) {
			return {};
		}
		var queryString = hash.substring(queryIndex + 1);

		return KidsHistoryManager._convertQueryStringToJSON(queryString);
	}
	/**
	 * Copied from tlcjs to fix decodeURI bug
	 * @param str
	 * @returns {{}}
	 * @private
	 */
	static _convertQueryStringToJSON(str) {
		var arr = str.split('&');
		var obj = {};
		for (var i = 0, len = arr.length; i < len; i++) {
			var bits = arr[i].split('=');
			obj[bits[0]] = decodeURIComponent(bits[1]);
		}
		return obj;
	}
	/**
	 * Get the current hash of the URL.
	 * @return {string}
	 * @private
	 */
	static _getHash() {
		var fullHash = location.hash.substring(1);
		var queryIndex = fullHash.indexOf('?');

		if (queryIndex == -1) {
			return fullHash;
		}

		return fullHash.substr(0, queryIndex);
	}
	static _convertObjectToQueryString(queryObject) {
		var retString = '';

		for (var key in queryObject) {
			if (Object.prototype.hasOwnProperty.call(queryObject, key) && key.length > 0) {
				var value = (queryObject[key])
					? encodeURIComponent(queryObject[key])
					: '';

				retString += key + '=' + value + '&';
			}
		}

		return retString;
	}
	static buildUrl(obj) {
		var url = obj.url;
		var query = KidsHistoryManager._convertObjectToQueryString(obj.query);

		if (query.length > 0) {
			return url + "?" + query;
		}

		return url;
	}
}

/**
 * A cache for the parsed querystring.
 * @type {Object|null}
 * @private
 */
KidsHistoryManager._query = null;
















